<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
        <i v-if="alert.type === 'success' || alert.type === 'warning'" class="icon fa fa-check"></i>
        <i class="icon fa fa-ban" v-else></i>
        {{'alert_'+alert.type | translate}}!</h4>
        <p v-if="alert.type !== 'danger'">{{alert.message}}</p>
        <ul v-else>
          <li v-for="e in alert.message">{{e}}</li>
        </ul>
       </b-alert>
    </template>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h2 class="box-title"><i class="fa fa-pencil-square-o mr-5"></i>{{'new_labels' | translate}}</h2>
      </div>
      <div class="box-controls">
        <div class="row">
          <multiselect v-model="company" :options="companies" placeholder="Select one" label="name" track-by="id"></multiselect>
        </div>
      </div>
      <div v-if="company.id === 0" class="box-body">
        <div class="callout callout-info">
          <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{'info' | translate}}</h4>
          <p>{{'no_label_existing_chose_company' | translate}}</p>
        </div>
      </div>
      <template v-else>
        <div class="box-body">
          <div class="row">
            <div class="form-group col-xs-12">
              <label class="pull-left">{{'label_type' | translate}}</label>
              <select class="form-control" v-model="info.type">
                <option class="normal" value="standard">{{'shipping' | translate}}</option>
                <option class="normal" value="returns">{{'return' | translate}}</option>
              </select>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-xs-12">
              <div class="row">
                <div class="form-group col-xs-12">
                  <label class="pull-left">{{'company' | translate}}</label>
                  <input class="form-control" name="company" :placeholder="'company' | translate" type="text" v-model="info.company">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-12">
                  <label class="pull-left">{{'name' | translate}}*</label>
                  <input v-validate="'required'" :data-vv-as="'name'| translate" class="form-control" name="last_name" :placeholder="'name' | translate" type="text" v-model="info.last_name">
                  <span v-show="errors.has('last_name')" class="small text-danger">{{ errors.first('last_name') }}</span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-9 col-xs-12">
                  <label class="pull-left">{{'street' | translate}}*</label>
                  <input v-validate="'required'" data-vv-as="Street" class="form-control" name="street" :placeholder="'street'| translate" type="text" v-model="info.street">
                  <span v-show="errors.has('street')" class="small text-danger">{{ errors.first('street') }}</span>
                </div>
                <div class="form-group col-sm-3 col-xs-12">
                  <label class="pull-left">{{'street_no' | translate}}*</label>
                  <input v-validate="{required: true, regex: '^[a-zA-Z0-9 ]*$'}" data-vv-as="Nr" class="form-control" name="street_no" :placeholder="'street_no'| translate" type="text" v-model="info.street_no">
                  <span v-show="errors.has('street_no')" class="small text-danger">{{ errors.first('street_no') }}</span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-3 col-xs-6">
                  <label class="pull-left">{{'zip_code' | translate}}*</label>
                    <input v-validate="'required|numeric'" data-vv-as="Nr" class="form-control" name="zip_code" :placeholder="'zip_code'| translate" type="text" v-model="info.zip_code">
                    <span v-show="errors.has('zip_code')" class="small text-danger">{{ errors.first('zip_code') }}</span>
                </div>
                <div class="form-group col-sm-6 col-xs-12">
                  <label class="pull-left">{{'city' | translate}}*</label>
                  <input v-validate="'required'" data-vv-as="City" class="form-control" name="city" :placeholder="'city'| translate" type="text" v-model="info.city">
                  <span v-show="errors.has('city')" class="small text-danger">{{ errors.first('city') }}</span>
                </div>
                <div class="form-group col-sm-3 col-xs-6">
                  <label class="pull-left">{{'country' | translate}}*</label>
                    <select class="form-control" v-model="info.country">
                      <option class="normal" v-for="c in Object.keys(countries)" :value="c">{{countries[c]}}</option>
                    </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12 col-xs-12">
                  <label>{{'parcel_options' | translate}}</label>
                    <select class="form-control" v-model="info.parcel_id">
                      <option class="normal" v-for="opt in parcelOptions" :value="opt.id">{{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})</option>
                    </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <template v-if="callback.label_url && callback.label_url !== ''">
            <div class="row">
              <div class="col-xs-6">
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Tracking ID: </label>
                    <span> {{callback.tracking_id}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Tracking No: </label>
                    <span> {{callback.tracking_number}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Tracking URL: </label>
                    <span><a :href="callback.tracking_url" target="_blank"> {{callback.tracking_url}}</a></span>
                  </div>
                </div>
              </div>
              <div class="col-xs-3">
                <a class="btn btn-info btn-app pull-right" :href="callback.label_url" target="_blank" download="label.pdf"><i class="fa fa-cloud-download"></i>Get Label</a>
              </div>
              <div class="col-xs-3">
                <a class="btn btn-warning btn-app pull-right" href="/labels"><i class="fa fa-retweet"></i>New Label</a>
              </div>
            </div>
          </template>
          <div v-else class="row">
            <div class="col-xs-12">
              <b-btn :disabled="errors.any()" class="btn btn-success btn-app pull-right" type="button" @click="createNewLabel"><i class="fa fa-save"></i>{{'submit' | translate}}</b-btn>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Materials',
  data () {
    return {
	    company: {
		    id: 0,
		    name: 'Select one'
	    },
      companies: [],
      parcelOptions: [],
      info: {
        type: 'standard',
        company: '',
        company_id: '',
        last_name: '',
        street: '',
        street_no: '',
        city: '',
        zip_code: '',
        country: 'DE',
        parcel_id: 1
      },
      callback: {
        label_url: '',
        tracking_id: '',
        tracking_url: '',
        tracking_number: ''
      },
      countries: require('../../filters/countries.json'),
      alerts: []
    }
  },
  computed: {
  },
  methods: {
    createNewLabel () {
      this.$validator.validate()
        .then(result => {
          if (result) {
          	this.info.company_id = this.company.id
            API.post('accounting/label/create', this.info)
              .then(response => {
                if (response.data.status === 'error') {
                  let alert = {type: 'danger', dismiss: 4, message: JSON.parse(response.data.message).errors}
                  this.$store.commit('pushAlert', alert)
                } else {
                  this.callback = response.data.data
                  let alert = {type: 'success', dismiss: 4, message: 'Success!'}
                  this.$store.commit('pushAlert', alert)
                }
              })
              .catch(error => {
                let alert = {type: 'danger', dismiss: 4, message: error.response.data.message}
                this.$store.commit('pushAlert', alert)
              })
          }
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      API.get('/orders/parcel-options')
        .then(res => {
          this.parcelOptions = res.data
        })
        .catch(error => {
          console.log(error)
        })
	    this.companies = this.$store.getters.companies
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .multiselect::placeholder {
    color: #ffffff !important;
  }
</style>
<style>
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/NewLabels.vue